import styled from 'styled-components';

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
	border-radius: 8px;
	position: relative;
`;

export const DropZone = styled.div<{ backgroundImage?: string }>`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	font-family: 'Inter', sans-serif;
	gap: 16px;
	padding: 48px;
	border: 2px dashed ${({ theme }) => theme.gray[400]};
	border-radius: 8px;
	background-color: ${({ theme }) => theme.gray[100]};
	background-image: ${({ backgroundImage }) =>
		backgroundImage ? `url(${backgroundImage})` : 'none'};
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	min-height: 300px;
	max-height: 600px;
	overflow: auto;
	cursor: pointer;
`;

export const DropZoneTitle = styled.div`
	font-size: 16px;
	font-weight: 500;
	color: ${({ theme }) => theme.gray[1000]};
`;

export const DropZoneLoading = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 8px;
`;

export const DropZoneLoadingText = styled.div`
	font-size: 14px;
	color: ${({ theme }) => theme.gray[600]};
`;

export const DragOverlay = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: ${({ theme }) => theme.gray[100]}DD;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 8px;
	z-index: 1;
	border: 2px dashed ${({ theme }) => theme.gray[600]};
`;

export const DragOverlayContent = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 8px;
`;

export const DragOverlayText = styled.div`
	font-size: 14px;
	color: ${({ theme }) => theme.gray[1000]};
`;

export const AltTagContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export const Description = styled.div`
	font-size: 14px;
	color: ${({ theme }) => theme.gray[600]};
	text-align: center;
`;

export const ErrorMessage = styled.div`
	font-size: 14px;
	color: ${({ theme }) => theme.red[500]};
	text-align: center;
	background-color: transparent;
	border-radius: 4px;
`;

export const ButtonContainer = styled.div`
	display: flex;
	gap: 12px;
	margin-top: 12px;
`;

export const ActionButton = styled.button`
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 8px 16px;
	background-color: ${({ theme }) => theme.gray[200]};
	border: 1px solid ${({ theme }) => theme.gray[200]};
	border-radius: 4px;
	font-size: 14px;
	font-weight: 500;
	color: ${({ theme }) => theme.gray[1000]};
	cursor: pointer;
	transition: all 0.2s;

	&:hover:not(:disabled) {
		background-color: ${({ theme }) => theme.gray[400]};
		border-color: ${({ theme }) => theme.gray[400]};
	}

	&:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}
`;
